<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">

                    <el-select v-model="formDatas.qpId" clearable placeholder="请选择试卷名称" @change="partserch"
                        size="small ">
                        <el-option v-for="(item, index) in qpId_arr" :label="item.qpName" :value="item.qpId"
                            :key="index">
                        </el-option>
                    </el-select>
                    <el-select v-model="formDatas.pdrId" clearable placeholder="请选择pk时间段名称" @change="partserch"
                        size="small ">
                        <el-option v-for="(item, index) in pdrId_arr" :label="item.pdrName" :value="item.pdrId"
                            :key="index">
                        </el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.qpStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="已创建" :value="1" key="1"></el-option>
                        <el-option label="答题中" :value="2" key="2"></el-option>
                        <el-option label="已答题" :value="3" key="3"></el-option>
                        <el-option label="已过期" :value="4" key="4"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="small" style="margin-right: 10px" @click="Out()">导出</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="qprId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 试卷详情 -->
            <el-dialog title="试卷详情" :visible.sync="isText" width="70%" top="8vh" :close-on-press-escape="false"
                :close-on-click-modal="false" @close="isText = false">
                <div style="width: 100%;display: flex;justify-content:space-around;" v-if="topicArr.pkqPaperTopicList">
                    <div class="textclass"
                        style="width: 100%;height: 60vh; overflow-y: auto;padding: 50px 50px 15px;overflow-x: hidden;">
                        <div>姓名: {{ topicArr.createusername }}</div>
                        <div>得分:{{ topicArr.qprShowScore }}</div>
                        <div id="" v-for="(item, index) in topicArr.pkqPaperTopicList || []" :key="index">
                            <p style="margin: 15px 0;font-size: 16px;">{{ index
                        + 1 }}.({{ item.qttName }}){{ item.qtName }}</p>
                            <el-radio-group v-model="checkList1[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                                v-for="(topic, n) in item.pkqTopicItemList" :key="n" style="display:block;"
                                text-color="red">
                                <el-radio :label="topic.qtiId" style="margin: 5px;" size="medium" border
                                    v-model="item.qptAnswerIds" disabled>{{
                        topic.qtiValue }}</el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-model="checkList1[index]" v-if="item.qttId == 2"
                                v-for="(topic, n) in item.pkqTopicItemList" :key="n">
                                <el-checkbox :label="topic.qtiId" style="margin: 5px;">{{ topic.qtiValue
                                    }}</el-checkbox>
                            </el-checkbox-group>
                            <el-input style="width: 100%;margin-left:0px;" v-model="checkList[index][0]"
                                placeholder="请输入答案" v-if="item.qttId == 4"></el-input>
                            <div :style="{ 'color': item.qtScoreRight === 2 ? 'green' : 'red' }"
                                style="font-size: 18px;margin: 15px;">{{ item.qtScoreRight === 2 ? '正确' : '错误' }}</div>
                        </div>
                    </div>
                </div>

            </el-dialog>
        </div>

    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import config from "../../api/env.js";
import {
    addIvqTopicClass, deleteIvqTopicClass, getPkqPaperRecordList, updateIvqTopicClass, getPkqPaperRecordDetails, getPkqDurationRuleList, getPkqPaperList
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            qpId_arr: [],
            pdrId_arr: [],
            checkList1: [],
            checkList2: [],
            isText: false,
            topicArr: [],
            fromArr: [],
            limit: 1,
            visitfileList: [],
            getNcVisitorItemList_data: [],
            getNcVisitorList_data: [],
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'qprId',
            dialog: false,
            edit: false,
            form: {

            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "qpName",
                    key: "qpName",
                    title: "试卷名称",
                    width: 180,
                    align: "center",
                    edit: false,
                    fixed: 'left',
                },
                {
                    field: "qpStatus",
                    key: "qpStatus",
                    title: "试卷状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.qprStatus == 1 ? <el-tag type="danger">未提交</el-tag> : <el-tag type="success">已提交</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "createusername",
                    key: "createusername",
                    title: "姓名",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "qprShowScore",
                    key: "qprShowScore",
                    title: "得分",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "qprTotalTime",
                    key: "qprTotalTime",
                    title: "答题总时间s",
                    width: 150,
                    align: "center",
                    edit: false,
                },

                {
                    field: "createtime",
                    key: "createtime",
                    fixed: 'left',
                    title: "创建时间",
                    width: 180,
                    align: "center",
                    edit: false,

                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style={{ 'color': row.characterCode }}

                                        on-click={() => this.DetailText(row)}
                                    >
                                        试卷详情
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                pdrId: '',
                qpId: '',
                qpStatus: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getPkqDurationRuleList().then(res => {
            this.pdrId_arr = res.data
        })
        getPkqPaperList().then(res => {
            this.qpId_arr = res.data
        })
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            const bulkdata = {
                ...this.formDatas,
            };
            var s = qs.stringify(bulkdata);
            this.openLoading();
            var that = this;
            axios({
                method: "post",
                url: config.baseURL + "/pkq-paper-record/exportPkqPaperRecord",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    userid: window.localStorage.getItem("paId"),
                },
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel",
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "答题结果.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success",
                    });
                }
            });

        },

        DetailText(row) {
            if (row.qprId) {
                getPkqPaperRecordDetails({ qprId: row.qprId }).then(res => {
                    this.topicArr = res.data;
                    this.checkList1 = [];
                    for (var i = 0; i < res.data.pkqPaperTopicList.length; i++) {
                        if (res.data.pkqPaperTopicList[i].qttId == 4) {
                            this.checkList1.push((res.data.pkqPaperTopicList[i].qptAnswerIds || ''))
                        } else {
                            this.checkList1.push((res.data.pkqPaperTopicList[i].qptAnswerIds || '').split(',').map(Number))
                        }

                    }

                    this.isText = true;
                })
            }
        },
        fromChange(e) {
            this.fromArr = [];
            if (e == 1) {
                getNcClueList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.ncName,
                            id: item.ncId
                        }
                        this.fromArr.push(s)
                    })
                });
            } else if (e == 2) {
                getNcNicheList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.nnName,
                            id: item.nnId
                        }
                        this.fromArr.push(s)
                    });
                })
            } else {
                getNcNicheProjectList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.nnpName,
                            id: item.nnpId
                        }
                        this.fromArr.push(s)
                    });
                })
            }
        },
        visitfileChange(file) {
            this.$set(this.form, 'nvsFiles', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvqTopicClass({ qprIds: row.qprId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;

            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvqTopicClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvqTopicClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();

        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.qprId = row.qprId
                    //console.log(jsonObj);
                    updateIvqTopicClass(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getPkqPaperRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getPkqPaperRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getPkqPaperRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },

};
</script>

<style>
.textclass .el-radio--medium.is-bordered {
    width: 100% !important;
    height: auto !important;
    padding: 5px 15px !important;
}

.textclass .el-radio {
    white-space: inherit !important;
    line-height: 2 !important;
}

.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>